import React, { useState } from 'react'
import Cookies from 'universal-cookie'

import Header from '@/layout/header'
import { Menu } from '@/layout/menu'
import { ModalChangePassword } from './modal-change-password'
import './styles.scss'

type Props = {
  children: React.ReactNode | React.JSX.Element
}

const AdminLayout = ({ children }: Props) => {
  const [isCollapsed, setIsCollapsed] = useState(false)
  const [toggleModal, setToggleModal] = React.useState(false)

  const onCloseModal = () => {
    setToggleModal(false)
  }

  return (
    <div className='app'>
      <Header setToggleModal={setToggleModal} />
      <ModalChangePassword toggleModal={toggleModal} onCloseModal={onCloseModal} />
      <div className='main__layout'>
        <Menu setIsCollapsed={setIsCollapsed} isCollapsed={isCollapsed} />
        <div className={isCollapsed ? 'content__layout--collapsed' : 'content__layout'}>{children}</div>
      </div>
    </div>
  )
}

export default AdminLayout
